import { useCallback } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useApi = () => {
  const { getToken } = useAuth();
  return useCallback(
    async (method, url, data, config = {}) => {
      const token = await getToken();
      const res = await axios({ method, url: `${API}${url}`, data, ...config, headers: { Authorization: `Bearer ${token}` } });
      return res.data;
    },
    [getToken]
  );
};

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return "يرجى التحقق من البيانات المدخلة";
  return "حدث خطأ، حاول مرة أخرى";
};

export const sar = (n) => `${Number(n || 0).toLocaleString("en-US", { maximumFractionDigits: 2 })} ر.س`;

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleString("ar-SA-u-nu-latn", { dateStyle: "medium", timeStyle: "short" }) : "";
